//引入安装的signalr包
import * as signalR from '@microsoft/signalr'

const instanceMessageHub = function (url, accessTokenFactory) {
  const connection = new signalR.HubConnectionBuilder()
    //服务器地址
    .withUrl(url, {
      accessTokenFactory: accessTokenFactory
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  //  自动重连
  async function start() {
    try {
      await connection.start()
      console.assert(connection.state === signalR.HubConnectionState.Connected);
      console.log("connected");
    } catch (err) {
      console.assert(connection.state === signalR.HubConnectionState.Disconnected);
      console.log(err);
      setTimeout(() => start(), 5000);
    }
  }
  connection.onreconnecting((error) => {
    console.assert(connection.state === signalR.HubConnectionState.Reconnecting);
    console.log("连接已丢失，正在尝试重新连接...");
  });
  connection.onclose(async () => {
    console.assert(connection.state === signalR.HubConnectionState.Disconnected);
    console.log("连接已断开，准备重新连接...");
    await start();
  })
  return connection;
}

//将创建的signal赋值给Vue实例
export default {
  //install方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
  install: function (Vue) {
    Vue.prototype.instanceMessageHub = instanceMessageHub;
  }
}